var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#37DCD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99437 7.13194L7.42837 5.55469C7.89819 4.79064 8.42348 4.06212 9 3.375C9.57555 4.05917 10.1001 4.78468 10.5694 5.54569L8.99437 7.13194ZM12.2107 8.71256C12.6529 9.95119 13.3014 11.1898 12.6832 12.3789C12.2899 13.1291 11.68 13.7435 10.9327 14.1424C8.89706 15.2224 6.37706 14.4292 5.30493 12.3789C4.68056 11.1898 5.40787 9.85331 5.85056 8.61525C6.25612 7.70231 6.66618 6.86081 7.13193 6.05194L8.99381 7.92731L10.8664 6.04181C11.3586 6.89344 11.7838 7.76925 12.2107 8.71256Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGup);
export default __webpack_public_path__ + "static/media/gup.9ec48cc86ac8abdd1c529c0764f6f334.svg";
export { ForwardRef as ReactComponent };